import React from "react";
import DocumentTitle from "react-document-title";
import { graphql } from "graphql";

import wrapMDCodeTabs from "../utils/wrapMDCodeTabs";
import generateTOC from "../utils/generateTOC";



export default function Template({
    data, // this prop will be injected by the GraphQL query below.
}) {
    const {
        markdownRemark: {
            html,
            frontmatter: { title },
            fields: { slug },
        },
        site,
    } = data;
    let content = wrapMDCodeTabs(html);
    content = generateTOC(content);

    return (
        <DocumentTitle title={`${title} | ${site.siteMetadata.title}`}>
            <div className="markdown">
                <h1>{title}</h1>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        </DocumentTitle>
    );
}

export const pageQuery = graphql`
    query DEBlogPostByPath($path: String!) {
        markdownRemark(fields: { slug: { eq: $path } }) {
            html
            frontmatter {
                title
            }
            fields {
                slug
            }
        }
        site {
            siteMetadata {
                title
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/templates/de.jsx